import React from 'react';
import { createPortal } from 'react-dom';
import './SafetyReportPrint.css'; // 공통 프린트 CSS

function SafetyReportApprovalModal({ show, onClose, appDoc }) {
  if (!show || !appDoc) return null;

  const handlePrint = () => {
    const printArea = document.getElementById('approval-printable-area');
    if (!printArea) return;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>전자결재 보고서 인쇄</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');
            body { font-family: 'Pretendard', sans-serif; background: #fff; padding: 20px; }
            .table-bordered th, .table-bordered td { border: 1px solid #000 !important; }
            .table-light { background-color: #f8fafc !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            
            /* A4 용지 규격 및 프린트 설정 */
            @page { size: A4 portrait; margin: 20mm; }
            @media print {
              body { margin: 0; padding: 0; }
              .no-print { display: none !important; }
            * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            }

            .editor-content-box { width: 100%; min-height: 500px; padding: 20px; border: 1px solid #dee2e6; margin-top: 20px; font-size: 0.95rem; line-height: 1.6; }
            .editor-content-box img { max-width: 100%; height: auto; }
            .editor-content-box table { width: 100% !important; border-collapse: collapse; }
            .editor-content-box th, .editor-content-box td { border: 1px solid #dee2e6; padding: 8px; }

            .aprv-table { border-collapse: collapse; text-align: center; font-size: 0.85rem; margin-bottom: 20px; margin-left: auto; }
            .aprv-table th, .aprv-table td { border: 1px solid #dee2e6; padding: 4px; }
            .aprv-table th { background: #f1f5f9; font-weight: 600; width: 80px; }
            .aprv-table td { width: 90px; vertical-align: middle; }
            
            .meta-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; margin-bottom: 20px; }
            .meta-table th { background: #f8fafc; border: 1px solid #dee2e6; padding: 8px; font-weight: 600; width: 120px; text-align: center; }
            .meta-table td { border: 1px solid #dee2e6; padding: 8px; }
          </style>
        </head>
        <body>
          ${printArea.innerHTML}
          <script>
            window.onload = function() { window.print(); };
            window.onafterprint = function() { window.close(); };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const docs = Array.isArray(appDoc) ? appDoc : [appDoc];
  const mainTitle = docs.length === 1 ? docs[0].title || '(제목 없음)' : `다중 인쇄 (${docs.length}건)`;

  return createPortal(
    <div className="report-viewer-overlay" style={{
      zIndex: 999999, background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(5px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }} onClick={onClose}>
      <div className="bg-white rounded-3 shadow-lg border-0 overflow-hidden"
        style={{ width: '100%', maxWidth: '980px', maxHeight: '92vh', display: 'flex', flexDirection: 'column' }}
        onClick={e => e.stopPropagation()}>
        
        {/* 상단 툴바 (비인쇄) */}
        <div className="text-dark px-4 py-3 d-flex justify-content-between align-items-center border-bottom bg-light">
          <h5 className="fw-bold mb-0">[전자결재] {mainTitle}</h5>
          <div className="d-flex gap-2">
            <button className="btn btn-primary btn-sm px-3 fw-bold" onClick={handlePrint}>
              <i className="fas fa-print me-2"></i>바로 인쇄
            </button>
            <button className="btn btn-secondary btn-sm px-3 fw-bold" onClick={onClose}>닫기</button>
          </div>
        </div>

        {/* 리액트 화면용 스타일 적용 */}
        <style>{`
          .approval-view-area { font-family: 'Pretendard', sans-serif; }
          .approval-view-area .editor-content-box { width: 100%; min-height: 500px; padding: 20px; border: 1px solid #dee2e6; margin-top: 20px; font-size: 0.95rem; line-height: 1.6; }
          .approval-view-area .editor-content-box img { max-width: 100%; height: auto; }
          .approval-view-area .editor-content-box table { width: 100% !important; border-collapse: collapse; }
          .approval-view-area .editor-content-box th, .approval-view-area .editor-content-box td { border: 1px solid #dee2e6; padding: 8px; }

          .approval-view-area .aprv-table { border-collapse: collapse; text-align: center; font-size: 0.85rem; margin-bottom: 20px; margin-left: auto; border: 1px solid #dee2e6; }
          .approval-view-area .aprv-table th, .approval-view-area .aprv-table td { border: 1px solid #dee2e6; padding: 4px; }
          .approval-view-area .aprv-table th { background: #f1f5f9; font-weight: 600; width: 80px; }
          .approval-view-area .aprv-table td { width: 90px; vertical-align: middle; }
          
          .approval-view-area .meta-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; margin-bottom: 20px; border: 1px solid #dee2e6; }
          .approval-view-area .meta-table th, .approval-view-area .meta-table td { border: 1px solid #dee2e6; padding: 8px; }
          .approval-view-area .meta-table th { background: #f8fafc; font-weight: 600; width: 120px; text-align: center; }
        `}</style>

        {/* 본문 (인쇄 영역) */}
        <div className="p-5 bg-white text-dark overflow-auto approval-view-area" id="approval-printable-area" style={{ flex: 1 }}>
          
          {docs.map((doc, idx) => {
            const title = doc.doc_title || doc.title || '(제목 없음)';
            const docNumber = doc.doc_no || doc.docNumber || doc.doc_number || '-';
            const draftDateStr = doc.make_date || doc.doc_date || doc.created_at || doc.draftDate || doc.updated_at || '';
            let draftDate = '-';
            if (draftDateStr) {
              const d = new Date(draftDateStr);
              if (!isNaN(d.getTime())) {
                draftDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
              }
            }
            const content = doc.doc_content || doc.content || '';
            const lines = doc.lines || [];
            let attachments = [];
            try { attachments = typeof doc.attachments === 'string' ? JSON.parse(doc.attachments) : (doc.attachments || doc.files || []); } catch(e){}

            return (
              <div key={doc.id || doc.aprv_id || idx} style={{ pageBreakAfter: idx < docs.length - 1 ? 'always' : 'auto', marginBottom: idx < docs.length - 1 ? '60px' : '0', maxWidth: '800px', margin: '0 auto' }}>
                
                <h2 className="text-center fw-bold mb-4" style={{ fontSize: '2rem', letterSpacing: '2px' }}>기 안 문</h2>

                {/* 결재선 (우측 상단 배치) */}
                {lines.length > 0 && (
                  <table className="aprv-table">
                    <tbody>
                      <tr style={{ height: '28px', background: '#f8fafc', color: '#334155' }}>
                        <th rowSpan="3" style={{ width: '40px', writingMode: 'vertical-rl', textOrientation: 'upright', letterSpacing: '4px', background: '#f8fafc', padding: '0' }}>결재</th>
                        {lines.map((l, i) => (
                          <th key={`role-${i}`} style={{ width: '90px', fontWeight: 600, padding: '4px' }}>{l.user_position || '-'}</th>
                        ))}
                      </tr>
                      <tr style={{ verticalAlign: 'middle' }}>
                        {lines.map((l, i) => {
                          const signImg = l.signature_url || l.signature || l.sign_url || l.sign_path || l.user_sign || (l.user ? (l.user.user_sign || l.user.signature_url || l.user.sign_url) : null);
                          return (
                            <td key={`stamp-${i}`} style={{ padding: '8px 4px' }}>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                <span style={{
                                  display: 'inline-block',
                                  padding: '2px 8px',
                                  borderRadius: '10px',
                                  border: `1px solid ${i === 0 ? '#a5b4fc' : '#86efac'}`,
                                  backgroundColor: i === 0 ? '#eef2ff' : '#dcfce7',
                                  color: i === 0 ? '#4338ca' : '#166534',
                                  fontWeight: 700,
                                  fontSize: '0.68rem',
                                  letterSpacing: '1px'
                                }}>
                                  {i === 0 ? '기안' : (i === lines.length - 1 ? '승인' : '검토')}
                                </span>
                                {signImg ? (
                                  <img src={signImg} alt="서명" style={{ maxHeight: '55px', maxWidth: '85px', objectFit: 'contain', margin: '2px 0' }} />
                                ) : (
                                  <span style={{ color: '#94a3b8', fontSize: '0.8rem', margin: '4px 0' }}>(인)</span>
                                )}
                                <span style={{ color: '#1e293b', fontWeight: 600, fontSize: '0.8rem' }}>{l.user_name || '-'}</span>
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                      <tr style={{ height: '28px' }}>
                        {lines.map((l, i) => {
                          const doneDate = l.done_date ? l.done_date.substring(0, 10) : draftDate;
                          return <td key={`date-${i}`} style={{ fontSize: '0.75rem', color: '#475569', padding: '4px' }}>{doneDate}</td>;
                        })}
                      </tr>
                    </tbody>
                  </table>
                )}

                {/* 메타데이터 (문서번호, 일자 등) */}
                <table className="meta-table">
                  <tbody>
                    <tr>
                      <th>작 성 자</th>
                      <td>{lines.length > 0 ? `${lines[0].user_name} ${lines[0].user_position || ''}` : '-'}</td>
                      <th>작 성 부 서</th>
                      <td>{doc.drafter_dept || doc.department || doc.dept_name || '-'}</td>
                    </tr>
                    <tr>
                      <th>문 서 번 호</th>
                      <td>{docNumber}</td>
                      <th>보 존 연 한</th>
                      <td>{doc.retentionPeriod || doc.retention_period || '3년'}</td>
                    </tr>
                    <tr>
                      <th>작 성 일 자</th>
                      <td>{draftDate}</td>
                      <th>공 개 범 위</th>
                      <td>{doc.publicScope || (doc.public_type === 'all' ? '전체' : (doc.public_type === 'dept' ? '부서' : '개인'))}</td>
                    </tr>
                    <tr>
                      <th>제 목</th>
                      <td colSpan="3" className="fw-bold">{title}</td>
                    </tr>
                  </tbody>
                </table>

                {/* 기안 본문 (에디터 출력) */}
                <div className="editor-content-box" dangerouslySetInnerHTML={{ __html: content }} />

                {/* 첨부파일 내역 목록 표 (모든 첨부파일 요약) */}
                {Array.isArray(attachments) && attachments.length > 0 && (
                  <div className="mt-4" style={{ pageBreakInside: 'avoid' }}>
                    <h5 className="fw-bold mb-2 d-flex align-items-center gap-1.5" style={{ fontSize: '1rem', color: '#1e293b' }}>
                      ■ 첨부파일 내역 (총 {attachments.length}건)
                    </h5>
                    <p className="text-muted mb-2" style={{ fontSize: '0.8rem' }}>* 아래 문서/사진 원본은 시스템(안전관리) 내 결재문서에 보관되어 있습니다.</p>
                    <table className="table table-bordered text-center align-middle mb-0" style={{ fontSize: '0.85rem' }}>
                      <thead className="table-light" style={{ background: '#f8fafc' }}>
                        <tr>
                          <th style={{ width: '10%' }}>순번</th>
                          <th style={{ width: '65%' }}>파일명</th>
                          <th style={{ width: '25%' }}>용량</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attachments.map((file, fIdx) => (
                          <tr key={file.id || fIdx}>
                            <td>{fIdx + 1}</td>
                            <td className="fw-bold text-dark" style={{ textAlign: 'left', paddingLeft: '1rem' }}>{file.originalName || file.name || file.original_name}</td>
                            <td>{file.size ? (file.size / 1024).toFixed(1) + ' KB' : '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                
                {idx < docs.length - 1 && (
                  <div className="no-print" style={{ textAlign: 'center', margin: '60px 0', borderTop: '2px dashed #94a3b8', position: 'relative' }}>
                    <span style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: '#fff', padding: '0 15px', color: '#64748b', fontSize: '0.9rem' }}>
                      <i className="fas fa-cut me-2"></i>문서 구분선 (다음 페이지)
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </div>,
    document.body
  );
}

export default SafetyReportApprovalModal;
